import React, { useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate, useSearchParams, Route, Routes } from 'react-router-dom'
import Profile from '../../components/Profile'
import '../../styles/css/Karyawan.css'
import searchIcon from '../../assets/icons/search-icon.svg'
import calenderIcon from '../../assets/icons/arrow-right.svg'
import { useDispatch, useSelector } from 'react-redux'
import Sidebar from '../../components/sidebar/Sidebar'
import {
    getSiswaAttendanceHistory,


    updateStateSiswaAttendance,
    resetTableAttendance
} from '../../features/siswaAttendanceHistorySlice'
import LoadingTable from '../../components/LoadingTable'
import Filter from '../../components/student/Filter'
import PilihTanggal from '../../components/jurnal/PilihTanggal'
import Table from '../../components/siswa-attendance-history/Table'
import IzinTable from '../../components/siswa-attendance-history/IzinTable'


import BelumValid from "../../assets/icons/Stat Icon-3.svg";
import Tepat from "../../assets/icons/tepat.svg";
import Telat from "../../assets/icons/telat.svg";
import Alpha from "../../assets/icons/alpha.svg";
import Tabbar from "../../components/Tabbar";
import {setCurrentKategori, setKategoriId} from "../../features/ketegoriSlice";
import Download from "../../components/siswa-attendance-history/Download";

const PRIMARY = '#3661EB'

const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

const listTabbar = [
    { id: 'absensi', kategori: 'Absensi' },
    { id: 'izin', kategori: 'Izin' },
]


function SiswaAttendanceHistory() {
    const {
        list,
        headers,
        isLoading,
        search,
        listKelas,
        kelas,
        startText, endText,
        startTime, endTime,
    } = useSelector(state => state.siswaAttendanceHistory)

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(null)

    useEffect(() => {
        if (location.pathname === '/kehadiransiswa') {
            navigate(`/kehadiransiswa/${listTabbar[0].kategori}`)
        }
    }, [location.pathname, navigate])

    useEffect(() => {
        dispatch(resetTableAttendance())
    }, [dispatch])

    useEffect(() => {
        const urlSearch = searchParams.get('search')
        const urlStartTime = searchParams.get('start_time')
        const urlEndTime = searchParams.get('end_time')
        const urlKelas = searchParams.get('kelas')

        if (urlSearch || urlStartTime || urlEndTime || urlKelas) {
            if (urlSearch) dispatch(updateStateSiswaAttendance({ name: 'search', value: urlSearch }))
            if (urlKelas) dispatch(updateStateSiswaAttendance({ name: 'kelas', value: urlKelas }))
            dispatch(getSiswaAttendanceHistory({
                search: urlSearch || '',
                start_time: urlStartTime || startTime,
                end_time: urlEndTime || endTime,
                kelas: urlKelas || ''
            }))
        } else {
            dispatch(getSiswaAttendanceHistory({}))
        }


    }, [])

    function handleSearch() {
        dispatch(getSiswaAttendanceHistory({ start_time: startTime, end_time: endTime, kelas: kelas || '', search }))
        dispatch(updateStateSiswaAttendance({ name: 'currentPage', value: 1 }))
        setSearchParams({
            search: search || '',
            start_time: startTime || '',
            end_time: endTime || '',
            kelas: kelas || ''
        })
    }

    const handleFilterChange = useCallback((selectedKelas) => {
        dispatch(updateStateSiswaAttendance({ name: 'currentPage', value: 1 }))
        dispatch(getSiswaAttendanceHistory({ start_time: startTime, end_time: endTime, kelas: selectedKelas || '', search }))
        setSearchParams({
            search: search || '',
            start_time: startTime || '',
            end_time: endTime || '',
            kelas: selectedKelas || ''
        })
    }, [startTime, endTime, search, dispatch, setSearchParams])

    function handleKeyDown(e) {
        if (e.key === 'Enter') handleSearch()
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='karyawan'>

                <div className='search-and-profile'>
                    <div className='wrap-search'>

                    </div>
                    <Profile />
                </div>


                {!isLoading && (
                    <div style={{ display: 'flex', marginBottom: 32, justifyContent: 'space-between' }}>
                        {[
                            { label: 'Total Siswa',     icon: BelumValid,     value: headers.total_siswa },
                            { label: 'Tepat Waktu',  icon: Tepat,  value: headers.siswa_datang_tepat_waktu },
                            { label: 'Telat Masuk',  icon: Telat,       value: headers.siswa_telat_masuk },
                            { label: 'Alpha',      icon: Alpha,  value: headers.alpha },
                        ].map((stat, i) => (
                            <div key={i} style={{
                                background: '#fff', borderRadius: 14,
                                border: `1px solid ${BORDER}`,
                                width: 285, height: 88, overflow: 'hidden', flexShrink: 0,
                                display: 'flex', alignItems: 'stretch',
                            }}>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '0 16px' }}>
                                    <div style={{
                                        width: 44, height: 44, borderRadius: 10, background: '#EFF6FF',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                        <img src={stat.icon} width={24} alt="" />
                                    </div>
                                    <div>
                                        <p style={{ margin: 0, fontSize: 14, color: '#64748B', fontWeight: 500 }}>{stat.label}</p>
                                        <p style={{ margin: '4px 0 0', fontSize: 22, color: PRIMARY, fontWeight: 700 }}>{stat.value}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}



                <div className='title-btn'>
                    <h1>Kehadiran Siswa</h1>


                    <div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px',width:500 }}>


                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari siswa"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateSiswaAttendance({name: 'search', value: e.target.value}))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>

                        <div className={'search-and-profile'} style={{ marginBottom:0 }}>
                            <div className={'wrap-search'}>

                                <div className='wrapper-pilih-tanggal'  >

                                    <style>{`
.btn-pilih-tanggal {
border: 1px solid ${BORDER};
border-radius: 10px;
}

.pilih-tanggal {
border: none !important;
}


  `}</style>

                                    <PilihTanggal
                                        text={startText}

                                        setText={updateStateSiswaAttendance}
                                        stateText='startText'
                                        setDate={setStartDate}
                                        date={startDate}
                                        setTime={updateStateSiswaAttendance}
                                        stateTime='startTime'
                                    />
                                    <img src={calenderIcon} alt="" />
                                    <PilihTanggal
                                        text={endText}
                                        setText={updateStateSiswaAttendance}
                                        stateText='endText'
                                        setDate={setEndDate}
                                        date={endDate}
                                        setTime={updateStateSiswaAttendance}
                                        stateTime='endTime'
                                    />
                                </div>

                            </div>
                        </div>

                        <button
                            className='btn-search'
                            style={{ gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48}}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt=""/></button>


                    </div>
                </div>


                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <div style={{
                        background: 'rgba(54,97,235,0.1)', border: '1px solid rgba(54,97,235,0.35)',
                        borderRadius: 100, padding: '6px 14px', display: 'inline-flex', alignItems: 'center',
                    }}>
                        <span style={{ fontSize: 10, fontWeight: 600, color: PRIMARY }}>Kelas {kelas.category ?? "-"}</span>
                    </div>
                </div>

                <div className='tabbar-filter'>
                    <Tabbar
                        options={listTabbar}
                        setKategoriId={setKategoriId}
                        setCurrentKategori={setCurrentKategori}
                        searchParams={''}
                        setKeterangan={updateStateSiswaAttendance}
                        path='/kehadiransiswa'
                        loading={false}
                    />
                    <div className='filter-angka'>
                        <Filter
                            option={listKelas}
                            setState={updateStateSiswaAttendance}
                            onFilterChange={handleFilterChange}
                        />
                        <Download />
                    </div>
                </div>

                {isLoading
                    ? <LoadingTable size={'large'} />
                    : <Routes>
                        <Route path='/absensi' element={<Table />} />
                        <Route path='/izin' element={<IzinTable />} />
                    </Routes>
                }
            </div>
        </div>
    )
}

export default SiswaAttendanceHistory
